<template>
  <div id="" class="x-addnews">
    <el-form ref="addnewsform" :model="addnewsform" label-width="80px" :rules="ruleForm">
      <el-form-item label="标题:" prop="name">
        <el-input v-model="addnewsform.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="上传封面:" class="x-css-label" prop='image'>
        <el-upload
        class="avatar-uploader"
        ref="upload"
        :on-success="myUpload"
        :before-upload="beforeAvatarUpload"
        :on-exceed="nomore"
        action="http://peixun.dlbbdk.com/upload/oss"
        :limit="1" :file-list="fileListImage"
        accept="image/jpeg,image/png,image/jpg"
        list-type="picture-card">
          <img src="imageUrl" class="avatar" v-if="imageUrl">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">建议上传图片尺寸为：150*150</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="内容:">
        <el-tabs v-model="activeName" class="x-addnews-tabs">
          <el-tab-pane label="编辑" name="first">
            <el-input type="textarea" v-model="addnewsform.desc" placeholder="请输入编辑内容"></el-input>
          </el-tab-pane>
          <el-tab-pane label="从微信公众号导入" name="second">
            <el-input v-model="addnewsform.wx" placeholder="请输入公众号文章链接"></el-input>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('addnewsform')" v-if="okupload">确认上传</el-button>
        <el-button type="primary" @click="gochange" v-if="okchange">确认修改</el-button>
        <!-- <el-button>取消上传</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  name: "addnews",
  data(){
    return{
      addnewsform:{
        name:'',
        desc:''
      },
      imageUrl:'',
      ruleForm:{
        name:[
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ]
      },
      fileListImage:[],
      imgossurl:'',
      activeName:'first',
      changeid:'',
      okupload:false,
      okchange:false,

    }
  },
  created(){
    // 判断是否修改
    if(this.$route.params.isedit == 1){
      this.fromeditpage(this.$route.params.classdata)
      this.okchange = true;
    }else{
      this.okupload = true;
    }
  },
  methods: {
    //确认修改
    gochange:function(){
      axios.get('/admin/article/edit', {
        params: {
          id:this.changeid,
          sec: localStorage.token,
          title:this.addnewsform.name,
          cover:this.imgossurl,
          url:this.addnewsform.wx,
          content:this.addnewsform.desc
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.$router.push({name:'maincompany'});

              this.$message({
                showClose: true,
                message: '修改资讯成功',
                type: 'success'
              });

        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 上传超过限制
    nomore(){
      this.$message({
        showClose: true,
        message:'超过限制啦！' ,
        type: 'error'
      });
    },
    beforeAvatarUpload(file){
      // console.log(file);
      // const isJPG = file.type === 'image/png';
      // const isLt2m = file.size / 1024 / 1024 < 2;
      // if(!isJPG){
      //   this.$message.error('上传头像图片只能是 JPG 格式!')
      // }
      // if(!isLt2m){
      //   this.$message.error('上传头像图片大小不能超过 2MB!')
      // }
      // return isJPG && isLt2m;
    },
    myUpload(res,content){
      console.log(res);
      if(res.status == 1){
        console.log(res.data[0].url);
        this.imgossurl = res.data[0].url;
      }else{
        this.$message({
          showClose: true,
          message:res.status.msg ,
          type: 'error'
        });
      }
    },
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.onSubmit()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    onSubmit(){
      axios.get('/admin/article/add', {
        params: {
          // id:this.changeid,
          sec: localStorage.token,
          title:this.addnewsform.name,
          cover:this.imgossurl,
          url:this.addnewsform.wx,
          content:this.addnewsform.desc
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.$router.push({name:'maincompany'});
              this.$message({
                showClose: true,
                message: '添加资讯成功',
                type: 'success'
              });

        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    // 显示修改内容
    fromeditpage(newsdata){
      this.addnewsform.name = newsdata.title;
      this.imgossurl = newsdata.cover;
      this.fileListImage.push({
        'url':newsdata.cover
      })
      this.addnewsform.desc = newsdata.content;
      this.addnewsform.wx = newsdata.url;
      this.changeid = newsdata.id;
    }
  }
}
</script>
<style >
  .el-form-item__content{
    text-align: left;
  }.x-addnews .el-input--small .el-input__inner{
    width: 320px;
  }.x-addnews-tabs .el-tabs__item{
    color: #BDA17A;
    border: 1px solid #BDA17A;
    background-color: #fff;
    border-radius: 5px;
    width: 120px;
    text-align: center;
    padding: 0;
    margin-right: 15px;
  }.x-addnews-tabs .el-tabs__item.is-active{
    color: #fff;
    border: 1px solid #BDA17A;
    background-color: #BDA17A;
    border-radius: 5px;
    width: 120px;
    text-align: center;
    padding: 0;
  }.x-addnews-tabs .el-tabs__active-bar{
    height: 0;
  }.x-addnews-tabs .el-tabs__nav-wrap::after{
    height: 0;
  }#tab-second{

  }
</style>



// WEBPACK FOOTER //
// src/components/addnews.vue